export const DATE_TIME_REPORTS = 'ddd Do MMM, h:mma' //Wed 1st Nov, 11:10 am
export const DATE_REPORTS = 'ddd Do MMM. YYYY' //Wed 1st Nov. 2023

//DATE TIME FORMATS
export const LONG_DATE_TIME_FORMAT = 'D MMMM YYYY, h:mma' // 1 November 2023, 5:00 am
export const SHORT_DATE_TIME_FORMAT = 'D MMM YYYY, h:mma' // 1 Nov 2023, 5:00 am
export const SLASHED_DATE_TIME_FORMAT = 'D/M/YYYY h:mma' // 1/11/2024 5:00AM
export const LONG_DATE_FORMAT_WITH_TIME = 'dddd, Do MMMM YYYY, h:mma' //Friday, 17th November 2023, 5:00 am

//DATE FORMATS
export const LONG_DATE_FORMAT = 'dddd, Do MMMM YYYY' //Friday, 17th November 2023
export const MEDIUM_DATE_FORMAT = 'D MMMM YYYY' // 1 November 2023
export const MEDIUM_DATE_NO_YEAR_FORMAT = 'Do MMMM' // 1st November
export const SHORT_DATE_FORMAT = 'D MMM YYYY' // 1 Nov 2023

//TIME FORMATS
export const TIME_FORMAT = 'h:mma' // 05:10 am

//API FORMATS
export const API_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss' // 2024-11-01T05:00:00 (DateTime)
export const API_DATE_FORMAT = 'YYYY-MM-DD' // 2023-11-01 (DateOnly)

export const DateTimeFormats = {
  DATE_TIME_REPORTS,
  DATE_REPORTS,
  LONG_DATE_TIME_FORMAT,
  SHORT_DATE_TIME_FORMAT,
  LONG_DATE_FORMAT,
  MEDIUM_DATE_FORMAT,
  SHORT_DATE_FORMAT,
  TIME_FORMAT,
  SLASHED_DATE_TIME_FORMAT,
  API_DATE_TIME_FORMAT,
  LONG_DATE_FORMAT_WITH_TIME,
  MEDIUM_DATE_NO_YEAR_FORMAT,
}

export enum RangeFilter {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Custom = 'custom',
}
